module.exports = __webpack_public_path__ + "static/media/dc_logo.8bd39586.png";